<template>
  <nav class="breadcrumbs">
    <ul class="list breadcrumbs_list">
      <li class="item">
        <NuxtLink
            :to="localePath('/')"
            aria-label="To home page"
        >
          <i class="g-csgo" />
          <span>{{ $t('main') }}</span>
        </NuxtLink>
      </li>
      <li
          v-for="(item, index) in items"
          :class="{ last: index === items.length - 1 }"
          class="item"
      >
        <NuxtLink
            :aria-label="`To ${item.title} page`"
            :to="item.link"
            rel="nofollow noindex"
        >
          <span>{{ item.title || '' }}</span>
        </NuxtLink>
      </li>
    </ul>
  </nav>
</template>

<script lang="ts" setup>
const props = withDefaults(
    defineProps<{
      items: { link: string, title: string }[]
    }>(),
    {items: () => []}
)
const localePath = useLocalePath()
</script>

<style lang="scss" scoped>


.breadcrumbs {
  display: flex;
  width: 100%;
  margin: 2rem 0;

  .g-csgo {
    margin-right: 1rem;
  }

  &_list {
    display: inline-flex;
    align-items: center;

    .item {
      display: inline-flex;
      align-items: center;

      a {
        display: inline-flex;
        align-items: center;
        font-weight: 300;
        font-size: 1.4rem;
        line-height: 150%;
        cursor: pointer;
        color: var(--surfaces-on-surface-variable);

        &:hover {
          color: var(--accent-on-accent-secondary);
        }
      }

      &.last a {
        color: var(--accent-on-accent-secondary);
        pointer-events: none;
        display: inline-block;
        max-width: 250px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      &:after {
        font-size: 0.8rem;
        margin: 0 1rem;
        color: var(--surfaces-on-surface);
        content: "\e800";
        font-family: "fontello";
        font-style: normal;
        font-weight: normal;
        speak: never;
        transform: rotate(-90deg);
        display: flex;
        text-decoration: inherit;
        text-align: center;
        font-variant: normal;
        text-transform: none;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        opacity: 0.3;
      }

      &.last:after {
        content: none;
      }
    }
  }

  @media screen and (max-width: 1024px) {
    height: 4.2rem;
    margin: 0;
    overflow: hidden;
    &_list {
      white-space: nowrap;
      overflow-y: hidden;
      overflow-x: auto;
      height: 4rem;
      padding-bottom: 0.5rem;

      .item {
        padding-top: 0.5rem;

        &.last {
          max-width: 150px;
        }
      }
    }
  }

  @media screen and (max-width: 600px) {
    &_list {
      .item {
        display: none;

        &:nth-last-child(2) {
          display: flex;
          flex-direction: row-reverse;

          a {
            color: var(--surfaces-on-surface-variable);
            pointer-events: auto;

            &:hover {
              color: var(--accent-on-accent-secondary);
            }
          }

          &:after {
            color: var(--surfaces-on-surface-variable);
            opacity: 1;
            display: inline-block;
            transform: rotate(90deg);
          }
        }
      }
    }
  }
}
</style>
